<script setup lang="ts">
import NavBar from "~/components/Navbar/NavBar.vue";
import Header from "~/components/Header/Header.vue";
import NavBarMobile from "~/components/Navbar/NavBarMobile.vue";
import { useNavbar } from "~/composables/navbar/useNavbar";
import { useAuthStore } from "~/store/auth/auth.store";
import { useEmbedStore } from "~/store/embed/embed.store";

const authStore = useAuthStore();
const embedStore = useEmbedStore();
const { isCollapsed: isNavbarCollapsed } = useNavbar();

const { $Localize } = useNuxtApp();

const typedLocalize: any = $Localize;

onMounted(() => {
  // No fetchProfile() here: this layout only ever mounts behind `auth.global.ts`, which guarantees
  // isLoggedIn() — and that getter already requires `user`. The profile was loaded by `login()`
  // (funnel) or by `auth-plugin.ts` (reload) before any layout mounted, so re-reading it was a
  // third /users/profile round trip on every login and every layout change.
  if (authStore.isLoggedIn()) {
    typedLocalize.setLanguage(authStore.user?.language);
  }
});
</script>

<template>
  <div :class="['layout_container navbar_layout', { navbar_collapsed: isNavbarCollapsed }]">
    <template v-if="!embedStore.isEmbed">
      <NavBar></NavBar>
      <NavBarMobile></NavBarMobile>
    </template>
    <div id="right_container" :class="['right_container', { embed: embedStore.isEmbed }]">
      <Header v-if="!embedStore.isEmbed"></Header>
      <div :class="['slot relative', { embed: embedStore.isEmbed }]">
        <slot />
      </div>
    </div>
  </div>
  <FeedbackContainer v-if="!embedStore.isEmbed"></FeedbackContainer>
</template>

<style scoped>
.layout_container {
  @apply flex flex-row min-h-full;
}

.right_container {
  @apply overflow-x-hidden overflow-y-hidden w-full h-[var(--app-viewport-height)];
  margin-left: var(--navbar_width);
  background: var(--white-main);
}

.right_container.embed {
  @apply ml-0 h-auto;
}

.slot {
  min-width: calc(100vw - var(--navbar_width));
  height: calc(var(--app-viewport-height) - var(--header_height));
}

.slot.embed {
  min-width: unset;
  height: var(--app-viewport-height);
}

@media (max-width: 768px) {
  .slot {
    @apply p-0;
  }
}

@media (max-width: 768px) {
  .right_container {
    @apply ml-0;
  }
}
</style>
